import { DataContext } from 'providers/data';
import { useLocation } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';

import { ParamsDataAdditionalServicesContacts } from 'utils/typeServices';

import { Box, Typography, AccordionSummary, AccordionDetails } from '@mui/material';

import NavTitle from 'components/views/NavTitle';
import { ButtonRectangle } from 'components/views/form/Button';

import HeaderSubPages from 'components/views/MyVehicles/HeaderSubPages';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import BannerRepairsFLR from '../../../assets/images/banner-repairs-flr-accessories.png';

import { CardSupplier, LinkCustom, AccordionCustom } from './styles';

const boxFlex = {
    display: 'flex',
    justifyContent: 'space-between'
}

const AdditionalServices = () => {
    const { state } = useLocation();
    const [detailsService, setDetailsService] = useState<ParamsDataAdditionalServicesContacts>();
    const { dataUsefulContacts, handleGetUsefulContacts } = useContext(DataContext);

    useEffect(() => {
        if (!dataUsefulContacts) {
            handleGetUsefulContacts({ token: localStorage.getItem('token')! });
        }

        if (state?.CdProduto && dataUsefulContacts?.ServicosAdicionaisContatos) {
            const selected = dataUsefulContacts?.ServicosAdicionaisContatos?.find(({ CdProduto }) => CdProduto === state?.CdProduto);
            setDetailsService(selected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, dataUsefulContacts]);

    return (
        <HeaderSubPages>
            <Box sx={boxFlex}>
                <Box sx={{ width: { xs: '100%', md: 'calc(100% - 16rem)' }, paddingBottom: '2rem', '#title-nav': { fontSize: '1rem' } }}>
                    <NavTitle title='Serviços adicionais' />
                    <Typography variant='h5' color='secondary.main' paddingTop='1.6875rem' fontWeight={600}>
                        {detailsService?.NomeServico}
                    </Typography>
                    <Typography variant='subtitle2' color='primary.light' padding='1.375rem 0 1.3125rem' fontWeight={700}>
                        Coberturas
                    </Typography>

                    {detailsService &&
                        <Box sx={boxFlex}>
                            <Box sx={{ width: { xs: '100%', md: '48%' } }}>
                                <Typography fontSize='1.125rem' paddingBottom='.9375rem' fontWeight={600}>
                                    {detailsService?.Descricao}
                                </Typography>

                                <CardSupplier>
                                    <Typography
                                        fontSize='.9375rem'
                                        sx={{
                                            textAlign: 'center',
                                            padding: '.8rem 0 .5rem',
                                        }}>
                                        Prestadora
                                        <strong> {detailsService?.Prestadora}</strong>
                                    </Typography>
                                    {detailsService?.Link !== "N/A" &&
                                        <LinkCustom to={detailsService?.Link}>
                                            <Typography
                                                fontSize='1.25rem'
                                                fontWeight={700}>
                                                Atendimento online
                                            </Typography>
                                            <ArrowForwardIosIcon />
                                        </LinkCustom>
                                    }
                                </CardSupplier>
                            </Box>
                        </Box>
                    }

                    <AccordionCustom>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                            <Typography>
                                Contatos
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{
                            width: '100%',
                            display: 'flex',
                            padding: '0 1rem',
                            justifyContent: 'center',
                        }}>
                            <a href={`tel:${detailsService?.Contato}`}>
                                {detailsService?.Contato}
                                <LocalPhoneOutlinedIcon />
                            </a>
                        </AccordionDetails>
                    </AccordionCustom>
                </Box>

                <Box sx={{ width: '30%', maxWidth: '14rem', position: 'relative', display: { xs: 'none', md: 'block' } }}>
                    <NavTitle title='Contrate já' />
                    <Box sx={{ marginTop: '1.375rem', 'img': { width: '100%', height: 'auto', borderRadius: '12px 12px 0 0' } }}>
                        <img src={BannerRepairsFLR} alt="banner" />
                        <Box sx={{
                            width: '100%',
                            top: '16.5rem',
                            display: 'flex',
                            borderRadius: '12px',
                            position: 'absolute',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'primary.main',
                        }}>
                            <Typography
                                fontSize='1.25rem'
                                color='white'
                                fontWeight={700}
                                textAlign='center'
                                width='fit-content'
                                padding='1rem 0 .75rem'
                                sx={{
                                    borderBottom: '1px solid #97C93D',
                                    lineHeight: '23px'
                                }}
                            >
                                Ainda não tem <br />
                                assistência 24h?
                            </Typography>

                            <Typography
                                fontSize='1.5rem'
                                color='white'
                                fontWeight={700}
                                textAlign='center'
                                width='fit-content'
                                padding='.75rem 0 .75rem'
                                sx={{
                                    lineHeight: '28px',
                                    'strong': {
                                        color: 'secondary.main'
                                    }
                                }}
                            >
                                Faça um
                                <br />
                                <strong>
                                    UPGRADE!
                                </strong>
                            </Typography>

                            <Box sx={{ paddingBottom: '.875rem', 'button': { fontSize: '.75rem', height: '1.875rem' } }}>
                                <ButtonRectangle name='CLIQUE AQUI' />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </HeaderSubPages>
    );
}

export default AdditionalServices;